import React from 'react';
import Input from './Input';

export default class TextInput extends React.Component {
    getValue() {
        return this.refs.input.state.value
    }

    validate(rule, errorMsg) {
        return this.refs.input.validate(rule, errorMsg);
    }

    render() {
        return <Input ref="input" {...this.props} type="text" />
    }
}



// WEBPACK FOOTER //
// ./src/components/Presentation/Forms/TextInput.js